//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    isHighlight: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    price: {
      type: [String, Number],
      required: true,
    },
    originalPrice: {
      type: [String, Number, null],
      required: true,
    },
    hasAllFeatures: {
      type: Boolean,
      default: false,
    },
    features: {
      type: Array,
      required: true,
    },
    ctaText: {
      type: String,
      required: true,
    },
    tier: {
      type: [String, Number],
      required: true,
    },
    showPricingInfo: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    parseFeature(feature) {
      // Add bold to templated slugs (like django)
      if (!feature.code_to_feature_conf) {
        return feature.feature;
      }

      const { quantity } = feature.code_to_feature_conf[this.tier - 1] || {};
      return feature.feature.replace('{{}}', `<b>${quantity || '&nbsp'}</b>`);
    },
    sentenceCase(str) {
      const newString = str.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase());
      return newString;
    },
  },
};
